import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Landing from "./Views/Landing";
import Sensor from "./Views/Sensor";
import { Login, Signup } from "./Views/Auth";
import ForgotPassword from "./Views/ForgotPassword";
import Onboarding from "./Views/Onboarding";
import Dashboard from "./Views/Dashboard";
import AddHorse from "./Views/AddHorse";
import HorseProfile from "./Views/HorseProfile";
import DailyLog from "./Views/DailyLog";
import Settings from "./Views/Settings";
import Privacy from "./Views/Privacy";
import Terms from "./Views/Terms";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/sensor" element={<Sensor />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/horses/new"
          element={
            <ProtectedRoute>
              <AddHorse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/horses/:horseId/edit"
          element={
            <ProtectedRoute>
              <AddHorse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/horses/:horseId"
          element={
            <ProtectedRoute>
              <HorseProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/horses/:horseId/log"
          element={
            <ProtectedRoute>
              <DailyLog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
